import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  horizontalWrapper: {
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
  },
  sidebar: {
    height: '100%',
    width: '260px',
    minWidth: '260px',
    borderRight: `1px solid ${theme.palette.divider}`,
    overflow: 'auto',
  },
  result: {
    padding: theme.spacing(4),
  },
}))
